import { CornerBumpOut } from "api/types/sketch";
import { Vector2 } from "api/types/sketch";
import { getAngle } from "functions/sketch/math";
import { makeAnglePositive } from "functions/sketch/math";
import { constructBumpoutCorner } from "../../corner/construct";

export function drawPrintCutBumpoutCorner(
    painter: any,
    i: number,
    previous_location: Vector2,
    current_location: Vector2,
    next_location: Vector2,
    corner_length: number,
    corner_depth: number,
    zoom: number
){
    const angle_A: number = makeAnglePositive(getAngle(previous_location, current_location) - 180, false);
    const angle_B: number = makeAnglePositive(getAngle(current_location, next_location) - 180, false);
    const outward_angle: number = Math.round((angle_A + angle_B) / 2 - (angle_A < angle_B ? 180 : 0));
    const corner_bumpout: CornerBumpOut = constructBumpoutCorner(
        previous_location,
        current_location,
        next_location,
        outward_angle,
        corner_length * zoom,
        corner_depth * zoom
    );

    let first_point: Vector2 | null = null;

    if(i === 0){
        first_point = corner_bumpout.A;
        painter.moveTo(corner_bumpout.A.X, corner_bumpout.A.Y);
    }
    else{
        painter.lineTo(corner_bumpout.A.X, corner_bumpout.A.Y);
    }
    
    painter.lineTo(corner_bumpout.B.X, corner_bumpout.B.Y);
    painter.lineTo(corner_bumpout.C.X, corner_bumpout.C.Y);
    painter.lineTo(corner_bumpout.D.X, corner_bumpout.D.Y);
    
    return {
        first_point: first_point,
        last_point: corner_bumpout.D
    }
}